import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { SelectableBox } from 'foundations-components/transitional/components/SelectableBox';
import { useCallback } from 'react';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function EmailOptionButton({
  emailOption,
  isSelected,
  onClick
}) {
  const {
    openUpgradeModal
  } = useUpgradeModal(emailOption.upgradeKey);
  const onClickButton = useCallback(() => {
    if (emailOption.isLocked) {
      openUpgradeModal();
    } else {
      onClick(emailOption.type);
    }
  }, [emailOption.type, emailOption.isLocked, onClick, openUpgradeModal]);
  return /*#__PURE__*/_jsx(SelectableBox, {
    marginBlockEnd: "200",
    marginInlineStart: "0",
    padding: "400",
    "data-test-id": `email-type-${emailOption.type}`,
    onClick: onClickButton,
    selected: isSelected,
    padded: true,
    type: "default",
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "row",
      alignItems: "center",
      children: [/*#__PURE__*/_jsx(Illustration, {
        name: emailOption.illustrationName,
        height: 80,
        width: 80
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        marginInlineStart: "300",
        maxInlineSize: "230px",
        children: [/*#__PURE__*/_jsxs(Flex, {
          flexDirection: "row",
          alignItems: "start",
          justifyContent: "space-between",
          children: [/*#__PURE__*/_jsx(H5, {
            children: emailOption.buttonLabel
          }), emailOption.isLocked && /*#__PURE__*/_jsx(View, {
            maxBlockSize: "24px",
            children: /*#__PURE__*/_jsx(Text, {
              as: "small",
              color: "icon-core-subtle",
              children: /*#__PURE__*/_jsx(LockBadge, {
                "data-test-id": "locked-selectable-box",
                size: "600"
              })
            })
          })]
        }), /*#__PURE__*/_jsx(Text, {
          as: "small",
          color: "do-not-use-slinky",
          textAlign: "left",
          children: emailOption.buttonDescription
        })]
      })]
    })
  });
}